// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__Y9jaO","rotate":"Loading_rotate__ZztiU"};